import * as React from "react";
import createSvgIcon from "../SvgIcon/createSvgIcon";

export default createSvgIcon(
  <React.Fragment>
    <g>
      <g>
        <path
          strokeWidth="3px"
          stroke="#1d1d1b"
          fill="#1d1d1b"
          d="M86.43,112.13c-30.5.04-55.35-24.74-55.39-55.24S55.79,1.54,86.29,1.5c30.5-.04,55.35,24.74,55.39,55.24.04,30.5-24.74,55.35-55.24,55.39ZM86.29,4.6c-28.79.04-52.18,23.49-52.15,52.29s23.49,52.18,52.29,52.15c28.79-.04,52.19-23.49,52.15-52.29S115.08,4.56,86.29,4.6Z"
        />
        <path
          fill="#1d1d1b"
          d="M86.74,103.97c-25.93.03-47.06-21.04-47.09-46.97S60.68,9.95,86.62,9.91c25.93-.03,47.06,21.04,47.09,46.97.03,25.93-21.04,47.06-46.97,47.09ZM86.62,13.01c-24.22.03-43.91,19.77-43.87,43.99.03,24.23,19.77,43.91,43.99,43.87,24.23-.03,43.91-19.77,43.88-43.99S110.84,12.98,86.62,13.01Z"
        />
        <path
          fill="#1d1d1b"
          d="M113.63,20.82c-10.12,3.14-17.09,11.93-25.5,17.86-2.22,1.57-4.56,2.88-7.11,3.83-2.82,1.05-5.74,1.83-8.6,2.77-5.14,1.68-10.27,4.06-13.72,8.4-3.08,3.86-5.63,11.23-.8,14.85,2.05,1.53,4.88,1.64,7.24.81,2.68-.94,4.57-2.96,6.41-5.03,1.64-1.84,3.34-3.38,5.66-4.29s4.85-1.32,7.32-1.66c5.14-.7,10.3-1.18,14.91-3.78s8.23-6.75,11.75-10.72c3.3-3.72,6.82-7.65,11.58-9.46,1.26-.48,2.13-1.69,1.75-3.08-.33-1.21-1.81-2.23-3.08-1.75-4.36,1.66-7.95,4.49-11.14,7.85-3.06,3.21-5.79,6.74-9.1,9.72s-7.06,4.69-11.45,5.47c-4.73.85-9.68.91-14.2,2.71-2.45.98-4.6,2.35-6.44,4.26-1.6,1.66-3.09,4.04-5.3,4.94-1.23.5-2.82.62-3.34-.5-.82-1.77.22-4.33,1.14-5.85,2.4-3.99,6.84-6.25,11.09-7.71,5.37-1.85,11.01-3.07,15.9-6.09s8.81-6.75,13.05-10.29c3.98-3.34,8.27-6.86,13.31-8.43,3.06-.95,1.76-5.78-1.33-4.82h0Z"
        />
        <path
          fill="#1d1d1b"
          d="M70.46,50.62c.23.07.45.14.67.22l.11.04c.14.06.15.06,0,0-.14-.06-.14-.06,0,0,.05.02.11.05.16.08.39.19.76.41,1.12.65.08.06.16.11.24.17.31.22-.26-.22.01,0,.18.15.36.31.53.47.31.29.56.69.88.96-.13-.11-.19-.25-.03-.03.07.1.14.19.2.29.12.18.24.36.34.55s.21.38.3.57c.05.11.1.21.15.32.09.2-.14-.36-.02-.05.15.41.28.82.38,1.24.03.11.05.23.07.35.01.06.02.12.03.17.02.14.01.08-.02-.18-.06.12.05.56.06.71.04.94.79,1.84,1.79,1.79.93-.04,1.84-.79,1.79-1.79-.21-4.58-3.41-8.71-7.82-10-.9-.26-1.99.32-2.21,1.25s.29,1.93,1.25,2.21h0Z"
        />
        <path
          fill="#1d1d1b"
          d="M91.13,42.29c.67.52,1.31,1.08,1.91,1.67.3.3.59.61.87.92.26.3.62.63.81.98-.06-.11-.17-.22-.04-.04.07.09.13.18.2.27.12.16.23.33.35.49.24.35.46.71.68,1.07s.42.74.61,1.11c.1.2.2.4.29.6.04.08.07.16.11.24.03.07.21.49.03.06.19.45.38.81.82,1.07.38.22.95.32,1.38.18.83-.27,1.64-1.28,1.25-2.21-1.48-3.5-3.73-6.63-6.74-8.97-.39-.31-.75-.53-1.27-.53-.44,0-.97.2-1.27.53-.59.64-.79,1.92,0,2.54h0Z"
        />
        <path
          fill="#1d1d1b"
          d="M107.16,28.28c.92,1.23,1.74,2.55,2.53,3.87.44.74.87,1.5,1.27,2.27.17.33.33.65.48.99.13.29-.01,0-.05-.13.02.07.06.14.08.21.06.15.11.29.15.44.27.9,1.27,1.56,2.21,1.25s1.54-1.24,1.25-2.21c-.49-1.6-1.38-3.11-2.23-4.54-.8-1.36-1.64-2.71-2.59-3.97-.29-.39-.59-.69-1.07-.82-.43-.12-1-.06-1.38.18-.74.48-1.24,1.65-.64,2.45h0Z"
        />
        <path
          fill="none"
          strokeWidth="4.25px"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          d="M50.97,100.88L5.15,156.97s-5.58,5.55-1.57,9.43c4.25,4.11,9.52-3.32,9.52-3.32l45.03-57.36-7.15-4.84Z"
        />
        <path
          fill="#1d1d1b"
          d="M127.71,25.12c2.04.06,4.14-.15,6.03-.96s3.15-2.24,4.19-4.01c1.89-3.22,4.77-5.53,8.52-6.15.15-.02.71-.1.26-.04.34-.04.67-.08,1.01-.11s.67-.04,1.01-.06c.7-.04.08-.01-.23-.2.13.07-.52-.45-.21-.14.35.34-.3-.46-.14-.18-.33-.59-.31-1.29.02-1.87-.15.27.22-.28.21-.27-.27.27.4-.29.14-.12-.39.26.32-.06-.27.12-.34.1-.67.2-1.02.28-1.04.24-2.09.33-3.14.53-2.05.4-4.19,1.19-5.56,2.83-1.25,1.5-1.84,3.42-3.2,4.85s-3.27,2.47-5.26,2.6c-1.3.09-2.42,1.05-2.42,2.42,0,1.24,1.11,2.51,2.42,2.42,4.99-.34,8.97-3.38,11.27-7.71.34-.65.66-1.41,1.28-1.84.86-.61,2.14-.8,3.15-.98,1.79-.31,3.73-.43,5.31-1.42,3.05-1.92,1.34-6-1.93-6.16-4.01-.2-8.14,1.3-11.24,3.78-1.05.84-1.93,1.81-2.74,2.87-.74.97-1.27,2.05-1.97,3.04-1.2,1.68-3.62,1.71-5.49,1.65-3.11-.1-3.11,4.74,0,4.84h0Z"
        />
      </g>
    </g>
  </React.Fragment>,
  "Stage1",
  {
    viewBox: "0 0 152.68 169.77",
    width: "77px",
    height: "76px",
  }
);
